import {Injectable} from '@angular/core';

import {GeneralService, SvgModelName} from 'ac-infra';
import {AuthGroup} from '../utilities/session-helper.service';
import {FileSelectionService} from '../components/file-selection/file-selection.service';
import {SessionService} from './session.service';
import {AuthorizationService} from './authorization.service';
import {TenantsRestService} from '../../network/services/apis/tenants-rest.service';
import {ServerInfoService} from "./server-info.service";

@Injectable({providedIn: 'root'})
export class LogoDisplayService {

    branding;// nuera for example

    tenantLogoUrl;
    whiteLabelLogoUrl;
    systemLogoUrl;
    systemLogoId;

    hasSession;

    private oneLiveMode;
    private isTenantUserOrMonitorLinkOrGroupUser;
    type: 'internal' | 'branding' | 'login' | 'whiteLabel' | 'tenant' | 'empty';

    constructor(
        private generalService: GeneralService,
        private fileSelectionService: FileSelectionService,
        private sessionService: SessionService,
        private tenantsRestService: TenantsRestService,
        private authorizationService: AuthorizationService
    ) {
    }

    updateLogos = () => {
        this.hasSession = !!this.sessionService.activeSession;
        this.oneLiveMode = ServerInfoService.oneLiveMode;
        const isTenantUser = this.authorizationService.validFor(AuthGroup.tenant_user);
        const isMonitorLinkOrSPOrChannelOrCustomerOperator = this.authorizationService.validForMonitorLinkOrOneLiveTenantUserOrGroupUsers();
        this.isTenantUserOrMonitorLinkOrGroupUser = isMonitorLinkOrSPOrChannelOrCustomerOperator || isTenantUser;

        this.branding = ServerInfoService.serverInfo?.branding;
        const whiteLabelLogoId = ServerInfoService.serverInfo?.whiteLabeling?.logoFileId;
        this.systemLogoId = ServerInfoService.serverInfo?.ovocSystemFileLogoId;

        if (this.sessionService.activeSession?.linkOperatorLogoId) {
            const logoObject = {logoId: this.sessionService.activeSession?.linkOperatorLogoId};
            this.initTenantLogo(logoObject).then(() => {
                this.finalizeLogoDecision();
            });
        } else if((this.sessionService.activeSession?.isSystemOperator || isTenantUser) && AuthorizationService.tenantScope){
            const tenant = this.tenantsRestService.getEntityById(AuthorizationService.tenantScope);
            if(tenant?.logoId !== -1){
                const logoObject = {logoId: tenant?.logoId};
                this.initTenantLogo(logoObject).then(() => {
                    this.finalizeLogoDecision();
                });
            }else{
                this.tenantLogoUrl = undefined;
                this.finalizeLogoDecision();
            }
        }else if (whiteLabelLogoId && !this.whiteLabelLogoUrl) {
            this.fileSelectionService.getLogoImage(ServerInfoService.serverInfo?.whiteLabeling, 'logoFileId').then((url) => {
                this.whiteLabelLogoUrl = url;
                this.finalizeLogoDecision();
            });
        } else if(this.systemLogoId && this.systemLogoId !== -1 && !this.systemLogoUrl){
            this.fileSelectionService.getLogoImage(ServerInfoService.serverInfo, 'ovocSystemFileLogoId').then((url) => {
                this.systemLogoUrl = url;
                this.finalizeLogoDecision();
            });
        } else {
            this.finalizeLogoDecision();
        }
    };


    finalizeLogoDecision = () => {
        if (this.isTenantUserOrMonitorLinkOrGroupUser && this.tenantLogoUrl) {
            this.type = 'tenant';
        } else if (this.whiteLabelLogoUrl) {
            this.type = 'whiteLabel';
        } else if (this.branding) {
            this.type = 'branding';
        } else if(this.systemLogoId && this.systemLogoId === -1){
            this.type = 'empty';
        } else if (!this.hasSession) {
            this.type = 'login';
        } else if (!this.isTenantUserOrMonitorLinkOrGroupUser || (!this.oneLiveMode && !this.tenantLogoUrl)) {
            this.type = 'internal';
        } else {
            this.type = 'empty';
        }
    };

    clear() {
        this.tenantLogoUrl = undefined;
    }

    initTenantLogo = (logoObject) => {
        return this.fileSelectionService.getLogoImage(logoObject, 'logoId').then((response) => {
            if (response !== -1) {
                this.tenantLogoUrl = response;
            }
            return response;
        });
    };

}
